<template>
  <div>
    <px-view-header v-if="!isModalView"
                    title="Solicitação"
                    title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-if="!loading && requisicao">
      <px-requisicao-detalhes-dados-basicos :requisicao="requisicao" @update="onUpdate"/>
    </div>
  </div>
</template>

<script>
import RequisicoesService from '@/modules/requisicao/requisicoes-service';
import RequisicaoDetalhesDadosBasicos from './RequisicaoDetalhesDadosBasicos.vue';

export default {
  props: {
    isModalView: {
      type: Boolean,
      default: false,
    },
    requisicaoIdProp: {
      type: [String, Number],
    },
  },
  data() {
    return {
      requisicaoId: null,
      requisicao: null,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de compras' },
        {
          text: 'Solicitações',
          to: '/requisicoes',
        },
        { text: 'Detalhes da solicitação' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.requisicoes' });
    },
    getRequisicao() {
      this.loading = true;
      RequisicoesService.getRequisicao(this.requisicaoId)
        .then(({ data }) => {
          this.requisicao = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onUpdate() {
      this.getRequisicao();
    },
  },
  created() {
    this.requisicaoId = this.requisicaoIdProp || this.$route.params.id;
    this.getRequisicao();
  },
  components: {
    pxRequisicaoDetalhesDadosBasicos: RequisicaoDetalhesDadosBasicos,
  },
};
</script>
